/* eslint-disable @typescript-eslint/no-explicit-any -- pre-existing legacy code, not touched in this pass; typing this properly is tracked separately */
import { useState } from "react";
import styles from "./IgnoreList.module.scss";

interface IgnoreListTypes {
  values: any;
  outputTitles: any;
  message: string;
}

export const IgnoreList = ({ values, message, outputTitles }: IgnoreListTypes) => {
  const [openWarning, toggleOpenWarning] = useState(false);

  return (
    <div className={styles["ignoreItemsWrap"]}>
      <div className={styles["messageWrap"]} onClick={() => toggleOpenWarning(!openWarning)}>
        <p className={styles["message"]}>{message}</p>
        <div className={`${styles["arrow"]} ${openWarning ? styles["rotate"] : ""}`}>{arrow}</div>
      </div>
      <div className={`${styles["tablesWrap"]} ${openWarning ? styles["visible"] : ""}`}>
        <div className={`${styles["ignoreItemsTable"]}`}>
          <div className={styles["titles"]}>{outputTitles}</div>
          {values}
        </div>
      </div>
    </div>
  );
};

const arrow = (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="chevron-down"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    className="svg-inline--fa fa-chevron-down fa-w-14 fa-3x"
  >
    <path
      fill="currentColor"
      d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357
          24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667
          22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
    />
  </svg>
);
